import React from 'react';
import { useFormikContext } from 'formik';
import { Field, renderFields } from '../Form';
import clsx from 'clsx';

export default function Columns({ columns, fields, className, inputClassName, gap = 'base' }) {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div
      className={clsx(
        'grid',
        {
          'grid-cols-1': columns === 1,
          'grid-cols-2': columns === 2,
          'grid-cols-3': columns === 3,
          'grid-cols-4': columns === 4,
          'grid-cols-5': columns === 5,
          'grid-cols-6': columns === 6,
          'gap-x-2 gap-y-2': gap === 'sm',
          'gap-x-4 gap-y-2': gap === 'base',
          'gap-x-8 gap-y-2': gap === 'lg',
        },
        className,
      )}
    >
      {renderFields({ fields, values, setFieldValue }).map(field => (
        <Field
          key={field.name}
          field={{
            ...field,
            visible: field.visible === undefined ? true : field.visible,
            noMargin: true,
          }}
          values={values}
          inputClassName={inputClassName}
        />
      ))}
    </div>
  );
}
